import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const CircleCloseIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6"
      width={width}
      height={height}
      viewBox="-4 -4 40 40"
    >
      <line
        data-color="color-2"
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        x1={22}
        y1={10}
        x2={10}
        y2={22}
        strokeLinejoin="miter"
      />
      <line
        data-color="color-2"
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        x1={22}
        y1={22}
        x2={10}
        y2={10}
        strokeLinejoin="miter"
      />
      <circle
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        cx={16}
        cy={16}
        r={15}
        strokeLinejoin="miter"
      />
    </svg>
  );
};
